// extracted by mini-css-extract-plugin
module.exports =  {"underground-icon":"_9330de7794--underground-icon--Cz5yU","underground-icon--regions":"_9330de7794--underground-icon--regions--UfBvq"};